import { render, staticRenderFns } from "./addBoradcast.vue?vue&type=template&id=600bd5a0&scoped=true&"
import script from "./addBoradcast.vue?vue&type=script&lang=js&"
export * from "./addBoradcast.vue?vue&type=script&lang=js&"
import style0 from "./addBoradcast.vue?vue&type=style&index=0&id=600bd5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600bd5a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600bd5a0')) {
      api.createRecord('600bd5a0', component.options)
    } else {
      api.reload('600bd5a0', component.options)
    }
    module.hot.accept("./addBoradcast.vue?vue&type=template&id=600bd5a0&scoped=true&", function () {
      api.rerender('600bd5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/boradcast/components/addBoradcast.vue"
export default component.exports